import sliceCreator from '../../index.jsx';
import {GET_PRE_SEASON_ACTIVITY_BY_ID} from '../../../constants/index.jsx';
const _getPreSeasonActivityByIdAction = sliceCreator('GET_PRE_SEASON_ACTIVITY_BY_ID', GET_PRE_SEASON_ACTIVITY_BY_ID, 'get');

const { asyncAction: getPreSeasonActivityByIdAction, reducer, clearData: clearGetPreSeasonActivityByIdAction } = _getPreSeasonActivityByIdAction;

export default reducer;

export {
    getPreSeasonActivityByIdAction,
    clearGetPreSeasonActivityByIdAction
}